import type { CollaborationMethod } from '../../types/ProductGroup';
import type { HowItWorksProps } from './HowItWorks';

export const howItWorksContent = (type: CollaborationMethod): HowItWorksProps => {
    const baseImageUrl = 'https://99designs-start-static.imgix.net/product-details/how-it-works';

    const contestAndContestBundleContent: HowItWorksProps = {
        title: __('How a contest works'),
        steps: [
            {
                title: __('01.'),
                description: __('Write a design brief'),
                image: {
                    src: `${baseImageUrl}/contest-1.jpg`,
                    alt: __('A person saying that they need a logo and filling out a design brief'),
                },
            },
            {
                title: __('02.'),
                description: __('Designers submit concepts'),
                image: {
                    src: `${baseImageUrl}/contest-2.jpg`,
                    alt: __('Four different designers submitting their designs'),
                },
            },
            {
                title: __('03.'),
                description: __('Pick a winning design'),
                image: {
                    src: `${baseImageUrl}/contest-3.jpg`,
                    alt: __('A person saying they love the design and selecting it as the winner'),
                },
            },
        ],
    };

    const typeMapping: Record<CollaborationMethod, HowItWorksProps> = {
        COLLABORATION_METHOD_CONTEST: contestAndContestBundleContent,
        COLLABORATION_METHOD_CONTEST_BUNDLE: contestAndContestBundleContent,
        COLLABORATION_METHOD_ONE_TO_ONE_PROJECT: {
            title: __('How a 1-to-1 project works'),
            steps: [
                {
                    title: __('01.'),
                    description: __('Write a design brief'),
                    image: {
                        src: `${baseImageUrl}/fixed-price-project-1.jpg`,
                        alt: __('A person filling out a design brief'),
                    },
                },
                {
                    title: __('02.'),
                    description: __('Choose a designer to work with'),
                    image: {
                        src: `${baseImageUrl}/fixed-price-project-2.jpg`,
                        alt: __('Four different designers and their design portfolios'),
                    },
                },
                {
                    title: __('03.'),
                    description: __('Collaborate on your design'),
                    image: {
                        src: `${baseImageUrl}/fixed-price-project-3.jpg`,
                        alt: __('A person and a designer collaborating on a design'),
                    },
                },
            ],
        },
        COLLABORATION_METHOD_STUDIO: {
            title: __('How a Studio project works'),
            steps: [
                {
                    title: __('Define'),
                    description: __('Work with us to define your brand'),
                    image: {
                        src: `${baseImageUrl}/studio-1.jpg`,
                        alt: __('A person having an idea and another person capturing it'),
                    },
                },
                {
                    title: __('Collaborate'),
                    description: __('We present 3 brand concepts and capture your feedback'),
                    image: {
                        src: `${baseImageUrl}/studio-2.jpg`,
                        alt: __('Three designers and their different designs'),
                    },
                },
                {
                    title: __('Bring to Life'),
                    description: __("We'll roll your brand out across your brand assets"),
                    image: {
                        src: `${baseImageUrl}/studio-3.jpg`,
                        alt: __('A person seeing their design on multiple assets'),
                    },
                },
            ],
        },
    };

    return typeMapping[type];
};
